import React, { useState,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaCog, FaEdit } from 'react-icons/fa';
import './PdfUpload.css';
import './Translation.css';
import { translateLesson } from '../../api/api';




const Translation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    selectedOptions = [],
    completedSteps = ['Audio Generation'],
   // fileName = '',
   // selectedLessons = [],
    currentStep='Translation',
    //stepFlow
  } = location.state || {};

  //const userEmail = 'Eezeelearn@gmail.com';

  const [language, setLanguage] = useState('');
  const  [selectedLessons,setSelectedLessons  ]  = useState([]);

  const [translatedTexts, setTranslatedTexts] = useState([]);
  const [translatedLessons, setTranslatedLessons] = useState([]);
  const [CompletedSteps, setCompletedSteps] = useState([]);
const [SelectedOptions, setSelectedOptions] = useState([]);
const [selectedLanguage, setSelectedLanguage] = useState('');
const [stepFlow, setStepFlow] = useState([]);
const [currentStepIndex, setCurrentStepIndex] = useState(0);
const [fileName, setFileName] = useState('');
const [userEmail, setUserEmail] = useState('Eezeelearn@gmail.com');


  

   const handleSignOut = () => {
       navigate(`/signin`);
  };;

  const handleLanguageChange = async (e) => {
    const lang = e.target.value;
    setLanguage(lang);

    try {
      const updated = await Promise.all(
        selectedLessons.map(async (lesson) => {
          const result = await translateLesson(lesson.content, lang);
          return {
            title: lesson.title,
            content: result.translated_text,
            editing: false
          };
        })
      );
      setTranslatedTexts(updated);
    } catch (err) {
      console.error('Translation error:', err);
    }
  };

  const toggleEditing = (index) => {
    setTranslatedTexts(prev => {
      return prev.map((item, i) =>
      i === index ? { ...item, editing: !item.editing } : item
    );
    
    });
  };

  const handleTextChange = (index, value) => {
    const updated = [...translatedTexts];
    updated[index].content = value;
    setTranslatedTexts(updated);
  };

  const handleBlur = (index) => {
    const updated = [...translatedTexts];
    updated[index].editing = false;
    setTranslatedTexts(updated);
    console.log(`Auto-saved: ${updated[index].title}`);
  };


   useEffect(() => {
  if (location.state) {
    setStepFlow(location.state.stepFlow || []);
    setCurrentStepIndex(location.state.currentStepIndex || 0);
    setFileName(location.state.fileName || '');
    setUserEmail(location.state.userEmail || 'Eezeelearn@gmail.com');
    setSelectedLessons(location.state.selectedLessons || []);
    setCompletedSteps(location.state.completedSteps || []);
    setSelectedOptions(location.state.selectedOptions || []);
  }
}, [location.state]);



  return (
    <div className="page-container">
      <div className="sidebar">
        <div className="sidebar-profile">
          <FaUserCircle className="sidebar-profile-icon" />
          <div className="sidebar-profile-name">{userEmail}</div>
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-item">My Projects</div>
          <div className="sidebar-item" onClick={() => navigate('/upload')}>New Project</div>

          <div className="sidebar-section">
            <div className="sidebar-item section-title">{fileName}</div>
            <div className="sidebar-submenu">
              <div className="sidebar-subitem enabled completed">PDF Upload</div>
              {stepFlow.map((step, index) => (
                <div
                  key={index}
                  className={`sidebar-subitem enabled  ${completedSteps.includes(step) ? 'completed' : ''} 
      ${step === currentStep ? 'current-step' : ''} 
      enabled`}>
                  {step}
                </div>
              ))}
            </div>
          </div>

          <div className="sidebar-item">
            <FaCog style={{ marginRight: '8px' }} /> Settings
          </div>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>

      <div className="translation-container">
        <div className="translation-columns">
          <div className="translation-col">
            <h4 className="translation-heading">Selected Lessons</h4>
            {(selectedLessons|| []).map((lesson, index) => (
              <div key={index} className="translation-box original-box">
                <div className="translation-title">{lesson.title}</div>
                <p className="translation-text">{lesson.content}</p>
              </div>
            ))}
          </div>

          <div className="translation-col">
            <div className="translation-header">
              <h4 className="translation-heading">Translated ({language})</h4>
              <select className="translation-dropdown" value={language} onChange={handleLanguageChange}>
                <option value="">Select Language</option>
                <option value="en">English</option>
                <option value="ta">Tamil</option>
                <option value="hi">Hindi</option>
                <option value="kn">Kannada</option>
                <option value="ml">Malayalam</option>
                <option value="sa">Sanskrit</option>
                <option value="te">Telugu</option>
                <option value="mr">Marathi</option>
              </select>
           


              
            </div>

            

            {language && translatedTexts.map((text, index) => (
              <div key={index} className="translation-box translated-box">
                <div className="translation-title">{text.title}</div>
                {text.editing ? (
                <textarea
                 className="translation-textarea"
                  value={text.content}
                  onChange={(e) => handleTextChange(index, e.target.value)}
                  onBlur={() => handleBlur(index)}
                  rows={4}
                  lang={language} // ✅ Use selected language tag (like 'ta', 'hi', etc.)
                  dir="auto"       // ✅ Automatically handles text direction
                style={{
              fontFamily: language === 'ta' ? 'Latha' :
                language === 'hi' ? 'Mangal' :
                language === 'ml' ? 'Noto Sans Malayalam' :
                language === 'te' ? 'Gautami' :
                language === 'kn' ? 'Tunga' :
                language === 'mr' ? 'Kokila' :
                'inherit',
              fontSize: '15px'
              }}
                />

                ) : (
                  <div className="translation-text editable">
                    <p>{text.content|| '[No content]'}</p>

                    
                    <FaEdit className="translation-edit-icon" onClick={() => toggleEditing(index)} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="translation-footer">
          <button className="translation-btn" onClick={() => navigate('text-extraction', {
      state: {
        selectedLessons,
        stepFlow,
        currentStepIndex: currentStepIndex - 1,
        fileName,
        userEmail,
        selectedOptions,
        completedSteps
      }
    })
  }>Back</button>
          <button className="translation-btn" onClick={() => navigate('/Audiogeneration', {
      state: {
       translatedLessons: translatedTexts, 
        selectedLessons, 
        selectedLanguage: language, 
        selectedOptions,
       stepFlow,
      completedSteps: [...completedSteps, 'Translation'],
    currentStep: 'Audio Generation',
    userEmail,
    fileName,
          autoGenerate: true       // NEW: trigger audio generation automatically
      },
    })
  }>Proceed for Audio Generation</button>
        </div>
      </div>
    </div>
  );
};

export default Translation;
